module.exports = __webpack_public_path__ + "img/qbdelete.34f0f338.svg";